import axios from 'axios';

export function attachmentClient() {
  let accessToken = undefined;
  const user = localStorage.getItem('user');

  if (user) {
    const userData = JSON.parse(user);
    accessToken = userData.accessToken;
  }

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  }

  return axios.create({
    headers,
  });
}
